import { render, staticRenderFns } from "./DealCol.vue?vue&type=template&id=0c68a6ca"
import script from "./DealCol.vue?vue&type=script&lang=js"
export * from "./DealCol.vue?vue&type=script&lang=js"
import style0 from "./DealCol.vue?vue&type=style&index=0&id=0c68a6ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports